<template>
  <v-form>
      <v-row align="center" justify="center">
        <h3><b>{{$t('json.docindexes')}}</b></h3>
      </v-row>
      <v-row  v-for="p in BatchSettings.Indexes" :key="p.Id" align="center" justify="center">
        <v-col :cols="1">
            <v-text-field clearable v-model="p.Name" @change="onChange" :disabled="disable || preview" :label="$t('json.ruleempty')" :rules="[() => !!p.Name || $t('json.ruleempty')]" required validate-on-blur></v-text-field>
        </v-col>
        <v-col :cols="1">
            <v-text-field clearable v-model="p.Caption" @change="onChange" :disabled="disable || preview" :label="$t('json.caption')" :rules="[() => !!p.Caption || $t('json.ruleempty')]" required validate-on-blur></v-text-field>
        </v-col>
        <v-col :cols="1">
            <v-select clearable v-model="p.DataType" @change="onChange" :disabled="disable || preview" :label="$t('json.datatype')" :items="docIndexTypes" validate-on-blur></v-select>
        </v-col>
        <v-col :cols="1">
            <v-text-field clearable v-model="p.Value" @change="onChange" :disabled="disable || preview" :label="$t('json.value')"  validate-on-blur></v-text-field>
        </v-col>
        <v-col :cols="1">
            <v-switch  v-model="p.CurrentDate" @change="onChange" :disabled="disable || preview" :label="$t('json.currentdate')"></v-switch>
        </v-col>
        <v-col :cols="1">
            <v-switch  v-model="p.Mandatory" @change="onChange" :disabled="disable || preview" :label="$t('json.mandatory')"></v-switch>
        </v-col>
        <v-col :cols="1" style="text-align: center;">
            <v-btn icon @click="removeProperty(BatchSettings.Indexes, p)" :disabled="disable || preview"><v-icon>mdi-server-remove</v-icon></v-btn>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col :cols="3">
          <v-btn v-show="!preview" block @click="addParameter" :disabled="disable">{{$t('json.addindex')}}</v-btn>
        </v-col>
      </v-row>
  </v-form>
</template>

<script>
import Models from '@/Models'
export default {
  name: 'IndexSettings',
  props: {
    props: {
      type: Object,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    BatchSettings () {
      return this.props
    },
    docIndexTypes () {
      return Models.DocIndexDataTypes
    }
  },
  methods: {
    async changeClassDefault (p) {
      this.BatchSettings.Classes.forEach(c => {
        if (c !== p) {
          c.Default = false
        }
      })
    },
    async removeProperty (arr, p) {
      const index = arr.indexOf(p)
      if (index > -1) arr.splice(index, 1)
      this.$emit('changeSettings')
    },
    getId () {
      return Math.floor(Math.random() * 1000000)
    },
    async addParameter () {
      const i = Models.DocIndex
      i.Id = this.getId()
      this.BatchSettings.Indexes.push(i)
    },
    async onChange (val) {
      this.$emit('changeSettings')
    }
  }
}
</script>
